export default __webpack_public_path__ + "static/media/frax.bbaec159.svg";